import { useWizardContext } from './WizardContext'
import type { WizardConfig } from './types'

/**
 * Hook pubblico per controllare il wizard da qualsiasi componente.
 *
 * @example
 * ```tsx
 * import { useWizard } from '~/components/wizard'
 * import { galCandidaturaWizard } from '~/components/wizard/configs/gal-candidatura'
 *
 * function MyPage() {
 *   const { startWizard } = useWizard()
 *   return (
 *     <button onClick={() => startWizard(galCandidaturaWizard)}>
 *       Avvia guida
 *     </button>
 *   )
 * }
 * ```
 */
export function useWizard() {
	const { startWizard, closeWizard, nextStep, prevStep, goToStep, activeWizard, currentStep, currentStepIndex, totalSteps, isFirstStep, isLastStep } = useWizardContext()

	return {
		/** Avvia un wizard. Passa `force=true` per ignorare il record di completamento. */
		startWizard: (config: WizardConfig, force?: boolean) => startWizard(config, force),
		/** Chiude il wizard corrente */
		closeWizard,
		/** Step successivo (o completa se è l'ultimo) */
		nextStep,
		/** Step precedente */
		prevStep,
		/** Salta a uno step specifico per indice */
		goToStep,
		/** Il wizard attualmente attivo (null se nessuno) */
		activeWizard,
		/** Lo step corrente (null se nessun wizard attivo) */
		currentStep,
		/** Indice dello step corrente (0-based) */
		currentStepIndex,
		/** Numero totale di step */
		totalSteps,
		/** True se è il primo step */
		isFirstStep,
		/** True se è l'ultimo step */
		isLastStep,
		/** True se un wizard è attivo */
		isActive: activeWizard !== null,
	}
}
